import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ButtonNewModule } from '../../common/button-new/button-new.module';
import { ButtonModule } from './../../common/button/button.module';
import { GroupModule } from './../../common/group/group.module';
import { IconModule } from './../../common/icon/icon.module';
import { ListSortableFormModule } from './../list-sortable-form/list-sortable-form.module';
import { ListSortableItemComponent } from './list-sortable-item.component';

@NgModule({
  declarations: [ListSortableItemComponent],
  exports: [ListSortableItemComponent],
  imports: [
    GroupModule,
    ButtonModule,
    CommonModule,
    IconModule,
    ListSortableFormModule,
    ButtonNewModule,
  ],
})
export class ListSortableItemModule {}
export { ListSortableItemComponent } from './list-sortable-item.component';
